import styled from 'styled-components';

const SectionDivider = styled.hr`
  border: none;
  width: 80px;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent,
    var(--accent, #D4AF37),
    transparent
  );
  margin: 0 auto;
  display: block;
`;

export { SectionDivider };
